module.exports = __webpack_public_path__ + "img/two.cae0be27.jpg";